export const ContextStateSymbol = Symbol('Context state identifier');
